package com.example.event_management_system

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize

private const val RECAPTCHA_SITE_KEY = "6Ld2NFYtAAAAALutX0QxiXODffy2y8zqlKAHVyrP"

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    Firebase.initialize(
        options = FirebaseOptions(
            applicationId = "1:375951011831:web:34fa0b26b7aacb293588f2",
            apiKey = "AIzaSyCpIhSPvHGOMx4KMv8xiO6voaPuB4L9v3E",
            projectId = "event-management-system-715d1",
            storageBucket = "event-management-system-715d1.firebasestorage.app",
            gcmSenderId = "375951011831",
            authDomain = "event-management-system-715d1.firebaseapp.com"
        )
    )
    initializeAppCheck()
    ComposeViewport {
        App()
    }
}

private fun initializeAppCheck() {
    js("""
        (function() {
            var key = '6Ld2NFYtAAAAALutX0QxiXODffy2y8zqlKAHVyrP';
            var host = window.location.hostname;
            if (host === 'localhost' || host === '127.0.0.1') {
                self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
            }
            var ac = require('firebase/app-check');
            var app = require('firebase/app').getApp();
            var provider = new ac.ReCaptchaV3Provider(key);
            ac.initializeAppCheck(app, { provider: provider, isTokenAutoRefreshEnabled: true });
        })()
    """)
}